import { BiTachometer } from 'react-icons/bi';
import { Resources } from '../resource';
import { TurnkeyAddressSearchPage } from './TurnkeyAddressSearchPage'

export const name = Resources.turnkeyAddressSearch;

export const list = TurnkeyAddressSearchPage;

export const icon = BiTachometer;

export const options = { label: 'resource.turnkeyAddressSearch' };
